import { Grid as MuiGrid } from "@mui/material";
import { useDropzone } from "react-dropzone";
import { dropZoneStyles } from "./DropZone.styles";
import { UPLOAD_ATTACHMENT_MAX_SIZE } from "app/shared/constants";

const DEFAULT_ACCEPT = {
  "image/png": [".png"],
  "image/jpeg": [".jpeg", ".jpg"],
  "image/gif": [".gif"],
  "image/tiff": [".tiff", ".tif"],
  "application/pdf": [".pdf"],
  "text/plain": [".txt"],
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document": [
    ".docx",
  ],
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [
    ".xlsx",
  ],
  "application/vnd.ms-excel": [".xls"],
  "application/vnd.ms-outlook": [".msg"],
};

export const DropZone = (props) => {
  const { getRootProps, getInputProps } = useDropzone({
    accept: props.accept || DEFAULT_ACCEPT,
    multiple: false,
    maxFiles: 1,
    maxSize: UPLOAD_ATTACHMENT_MAX_SIZE,
    onDropAccepted: (droppedFiles, event) => {
      props.handleDrop?.(droppedFiles, event);
      props.handleDocumentUpload?.(droppedFiles);
    },
    onDropRejected: (fileRejections, event) => {
      props.handleDropRejected?.(
        fileRejections.map((rejection) => rejection.file),
        event,
      );
    },
  });

  return (
    <MuiGrid sx={dropZoneStyles}>
      <MuiGrid {...getRootProps({ className: "dropzone-root" })}>
        <input {...getInputProps()} />
        <MuiGrid className="dropzone-text">{props.dropzoneText}</MuiGrid>
      </MuiGrid>
    </MuiGrid>
  );
};
